import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['format', 'tone', 'length']

  connect() {
    // Controller connected
  }

  selectFormat(event) {
    const value = event.currentTarget.getAttribute('data-value')
    this.formatTarget.value = value
    this.updateActiveButton(event.currentTarget)
  }

  selectTone(event) {
    const value = event.currentTarget.getAttribute('data-value')
    this.toneTarget.value = value
    this.updateActiveButton(event.currentTarget)
  }

  selectLength(event) {
    const value = event.currentTarget.getAttribute('data-value')
    this.lengthTarget.value = value
    this.updateActiveButton(event.currentTarget)
  }

  updateActiveButton(clickedButton) {
    // Find the button group containing this button
    const btnGroup = clickedButton.closest('.btn-group')
    if (btnGroup) {
      // Remove active class from all buttons in this group
      btnGroup.querySelectorAll('.btn').forEach(btn => {
        btn.classList.remove('active')
      })
      // Add active class to clicked button
      clickedButton.classList.add('active')
    }
  }
}
